import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs1 from "./page_us/Solution-US-1/SectionUs1.js";




const PlafondsMursTendus = () =>{
    useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Plafond Tendu Maroc | Murs & Plafonds Stretch LED – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Plafonds et murs tendus au Maroc avec UNIK SYSTEM : solutions PVC haut de gamme, design moderne, éclairage LED intégré et finition parfaite. Installation rapide."
  );

  setMeta(
    "keywords",
    "plafond tendu maroc, mur tendu maroc, toil tendu maroc, mur decoratif maroc, mur design maroc,plafond stretch maroc, plafond pvc maroc, plafond led maroc, plafond lumineux maroc, plafond acoustique maroc, mur decoratif maroc, plafond tendu casablanca, plafond tendu rabat, plafond tendu marrakech, UNIK SYSTEM stretch"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/plafond-mur-tendu-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Plafond Tendu Maroc – Design & LED | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Plafonds et murs tendus design avec éclairage LED intégré pour maisons, bureaux et commerces au Maroc."
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:url", "https://unik-system.com/plafond-mur-tendu-maroc");
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/SLIDE_oxygene-experience-spa-casablanca-2.8b7ddab767ae88d6850f.jpg"
  );
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Plafond Tendu Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solutions modernes de plafonds et murs tendus avec LED au Maroc."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/SLIDE_oxygene-experience-spa-casablanca-2.8b7ddab767ae88d6850f.jpg"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    logo: "https://unik-system.com/logo.png",
    description:
      "Entreprise spécialisée en plafonds et murs tendus au Maroc. Solutions modernes avec design et LED.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    sameAs: [
      "https://www.facebook.com/uniksystem",
      "https://www.instagram.com/uniksystem"
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Plafonds & Murs Tendus",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Plafond Tendu LED"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Mur Tendu Décoratif"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-stretch-pro");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-stretch-pro";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA (BOOST GOOGLE) =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C'est quoi un plafond tendu ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Un plafond tendu est une toile PVC installée sous le plafond existant pour un rendu moderne et esthétique."
        }
      },
      {
        "@type": "Question",
        name: "Est-ce que le plafond tendu est durable ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Oui, il est résistant, durable et facile à entretenir pendant plusieurs années."
        }
      },
      {
        "@type": "Question",
        name: "Peut-on intégrer des LED ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Oui, les plafonds tendus permettent une intégration parfaite des éclairages LED pour un effet lumineux moderne."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-stretch");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-stretch";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs1/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;